import {useSelector} from 'react-redux';

import AemButton from '@/components/Aem/AemButton';
import {ArrowSmallIcon} from '@/components/Icons';
import InlineProgress from '@/components/InlineProgress/InlineProgress';
import amplitudeLoyaltyTracking from '@/services/analytics/amplitude/amplitudeLoyaltyTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appRouterService from '@/services/route/appRouterService';
import {selectAllJourneys, selectCompletedJourneys, selectIsLoyaltyJourneysFetched} from '@/state/selectors/consumerLoyalty';

const DcxTopBannerLoyaltyContent = ({bannerData}) => {
    const isLoyaltyJourneysFetched = useSelector(selectIsLoyaltyJourneysFetched);

    const {title, button} = bannerData || {};
    const {allBadgesCount, completedBadgesCount, progress} = useProgress();

    const onClick = () => {
        amplitudeLoyaltyTracking.trackViewAllButtonClick();
        googleAnalyticsService.trackViewAllButtonClick();
        appRouterService.forwardToLoyaltyPage();
    };

    if (!isLoyaltyJourneysFetched) return null;

    return (
        <div className='animate-fade-in text-primary-dark md:text-romance'>
            <h1 className='m-0 p-0 text-18 tracking-04'>{title}</h1>
            <div className='flex flex-row items-end'>
                <span className='text-32 leading-125'>{completedBadgesCount}</span>
                <span className='text-18'> /{allBadgesCount}</span>
            </div>
            <InlineProgress
                className='mt-4 w-full bg-primary-dark md:max-w-[360px] md:bg-romance'
                progress={progress}
                progressClassName='bg-tertiary'
            />
            <AemButton raw onClick={onClick} className='mt-2 font-normal tracking-05 text-inherit' {...button}>
                <ArrowSmallIcon />
            </AemButton>
        </div>
    );
};

export default DcxTopBannerLoyaltyContent;

const useProgress = () => {
    const allJourneys = useSelector(selectAllJourneys);
    const completedJourneys = useSelector(selectCompletedJourneys);
    const allJourneysCount = allJourneys?.length || 0;
    const completedBadgesCount = completedJourneys?.length || 0;
    const progress = allJourneysCount > 0 ? (completedBadgesCount / allJourneysCount) * 100 : 0;

    return {allBadgesCount: allJourneysCount, completedBadgesCount, progress};
};
